import { Button, Tag } from "antd";
import type { TagProps } from "antd";
import { DocEditor } from "../document-decentralize-title-table";
import { memo, useState } from "react";
import { FontFa } from "../../../../../components";

interface Props extends TagProps {
  Permissions?: DocEditor[];
  onRevoke?: (data: { id: string; user: DocEditor }) => void;
}

const EditorGrantedUsers = (props: Props) => {
  const { Permissions = [], onRevoke = () => {}, ...tagProps } = props;
  const [expanded, setExpanded] = useState(false);

  const handleClose = ({ id, user }: { id: string; user: DocEditor }) => {
    onRevoke({ id, user });
  };

  const displayedTags = expanded ? Permissions : Permissions.slice(0, 10);

  // const renderedTags = (tags: DocEditor[]) => {
  //   return tags.map((tag) => (
  //     <Tag key={tag.Id} closable onClose={() => handleClose({ id: tag.Id!, user: tag })} {...tagProps}>
  //       {tag.displayName}
  //     </Tag>
  //   ));
  // };

  return (
    <>
      {displayedTags.map((tag: any) => (
        <Tag key={tag.Id} closable onClose={() => handleClose({ id: tag.Id, user: tag })} {...tagProps} className="my-1">
          {tag.employeeName}
        </Tag>
      ))}
      {Permissions.length > 10 && (
        <Button
          type="link"
          onClick={() => setExpanded(!expanded)}
          style={{ fontWeight: "bold", color: "#1890ff" }}
        >
          <span className="mr-1">{expanded ? "Thu gọn" : "Xem thêm"}</span>
          <FontFa name={expanded ? "faArrowUp" : "faArrowDown"} />
        </Button>
      )}
    </>
  );
};

export default memo(EditorGrantedUsers);
